import Swal from "sweetalert2";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { const_routes } from "../helpers/const_routes";
import { t } from "i18next";
import { startLogout } from "./authActions";

export const startRegisterGroupConcernList = (groupConcerns, navigate) => {
  return async (dispatch) => {
    //const groupConcernsObjectSend = {
    //  groupConcernsObject:  groupConcerns ,
    //};

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_GROUP_CONCERN}`,
      "add-list",
      groupConcerns,
      "POST"
    );
    const body = await resp.json();

    if (body.ok) {
      dispatch(registerGroupConcernsList(groupConcerns));

       Swal.fire({
              title: t("titles.success"),
              text: t("record.save"),
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              confirmButtonText: t("buttons.close")
            }).then((result) => {
              if (result.isConfirmed) {
                //setTimeout(() => {
                  //navigate("/specialist-technology");
                //}, 5000);
              }
            });


    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const registerGroupConcernsList = (groupConcern) => ({
  type: types.GROUPCONCERN_START_REGISTER_LIST,
  payload: groupConcern,
});